import { FeedbackProps, NpsDataProps } from "@/interfaces/NpsData";
import { createContext, useContext } from "use-context-selector"

export interface NpsContextType {
  loading: boolean;
  npsAtendimentos?: NpsDataProps;
  feedback?: FeedbackProps;
  getNpsAtendimentos: (params?: object) => Promise<void>;
  getFeedback: (atendimento_id: number) => Promise<string>;
}

export const NpsContext = createContext<NpsContextType>(undefined);
export const useNps = () => useContext(NpsContext);